"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateDisplayPrefOptions = exports.datePreferences = void 0;
exports.datePreferences = {
    mdy: 'Month/Day/Year',
    dmy: 'Day/Month/Year',
    ymd: 'Year/Month/Day',
};
exports.dateDisplayPrefOptions = new Set([
    { text: 'Month/Day/Year', value: 'mdy' },
    { text: 'Day/Month/Year', value: 'dmy' },
]);
